import type { IGetCollectionOrderStatus } from '../../domain/use-cases/i-get-collection-order-status'
import type { GetCollectionOrderStatusRequest } from '../../domain/models/get-collection-order-status'
import type { ApiResponse } from '../../../../config/api-types'

export class GetCollectionOrderStatusController {
  constructor(private readonly repository: IGetCollectionOrderStatus) {}

  async getStatus(params: GetCollectionOrderStatusRequest): Promise<ApiResponse> {
    try {
      const result = await this.repository.getStatus(params)
      return result
    } catch (error) {
      throw error
    }
  }
}